<template>
  <div>
    <integration-page
      :integration-name="'outlook'"
      :svg="outlookIcon"
      :links="links"
      :is-first-link="isFirstLink"
      @handleDelete="onOkDeletePopup"
      @firstLinkWasOpen="firstLinkWasOpen"
    />
  </div>
</template>

<script>

import _ from 'lodash';
import outlookIcon from '../../../svg/integration/settings/outlookCalendarSmall.svg';
import IntegrationPage from '../googleOutlookIntegrations/integrationPage.vue';
import projectComponent from '../../../components/Project';

export default {
  name: 'OutlookIntegration',
  components: {
    IntegrationPage,
  },
  data() {
    return {
      locale: __,
      outlookIcon,
    };
  },
  computed: {
    links() {
      const projectsData = projectComponent.getProjectsList();

      const links = this.$store.getters['integrationOutlook/outlookLinks'] || [];

      const projectsIds = _.cloneDeep(projectsData.filter(item => item.type === 'project' && !item.is_jira)).map(item => item.id);

      if (links.length) {
        const updatedData = links.filter(link => link.connectionType === 'all_tasks' || projectsIds.includes(link.projects[0].ganttId));

        return updatedData;
      }

      return [];
    },
    isFirstLink() {
      return this.$store.getters['integrationOutlook/isFirstLink'] || false;
    },

  },
  methods: {

    onOkDeletePopup(link) {
      this.$store.dispatch('integrationOutlook/deleteLink', link);
      userExtAnalytics.log('integration_outlook_calendar_deleted');
    },
    firstLinkWasOpen() {
      this.$store.commit('integrationOutlook/setFirstLink', false);
    },
  },
};
</script>

<style module src="../googleOutlookIntegrations/googleOutlookIntegration.less"></style>
